import { OPEN_INTEREST_SECTION, OPEN_INTEREST_SECTION_STREAM, } from "../../interface/iOpenInterest";
import { openInterestAnalysisStreaming } from "@domains/features/Markets/Futures/utils/streamingUpdate";
const initState = {
    data: {},
};
const OpenInterest = (state = initState, action) => {
    var _a;
    switch (action.type) {
        case OPEN_INTEREST_SECTION:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case OPEN_INTEREST_SECTION_STREAM:
            return Object.assign(Object.assign({}, state), { data: {
                    lut: (_a = action.payload.qouteStream) === null || _a === void 0 ? void 0 : _a.updatedTime,
                    data: openInterestAnalysisStreaming(state.data.data, action.payload.qouteStream),
                } });
        default:
            return state;
    }
};
export default OpenInterest;
